import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./lib/LanguageContext";

// Public Pages (German/English)
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";

// Admin Pages (Albanian)
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminServices from "./pages/admin/AdminServices";
import AdminFAQs from "./pages/admin/AdminFAQs";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminSEO from "./pages/admin/AdminSEO";
import AdminProfile from "./pages/admin/AdminProfile";
import AdminSocialMedia from "./pages/admin/AdminSocialMedia";

// Layout
import PublicLayout from "./layouts/PublicLayout";
import AdminLayout from "./layouts/AdminLayout";

function App() {
  return (
    <LanguageProvider>
      <Toaster position="top-right" richColors closeButton />
      <BrowserRouter>
        <Routes>
          {/* Public Routes (German/English) */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/leistungen" element={<ServicesPage />} />
            <Route path="/leistungen/:slug" element={<ServiceDetailPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
          </Route>

          {/* Admin Routes (Albanian) */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="faqs" element={<AdminFAQs />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="social-media" element={<AdminSocialMedia />} />
            <Route path="seo" element={<AdminSEO />} />
            <Route path="settings" element={<AdminSettings />} />
            <Route path="profile" element={<AdminProfile />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
